import React from 'react'
import { InjectedIntlProps, injectIntl } from 'react-intl'

import { AttractionImage } from 'src/components/attraction-image'

import { AttractionWidget } from '../AttractionWidget/AttractionWidget'
import locale from '../locale'

import { AttractionCardProps } from './AttractionCard'

const style = require('./AttractionCard.css')

const HeadlinerAttractionCardComponent = ({
  attraction,
  onClick,
  intl,
}: AttractionCardProps & InjectedIntlProps) => {
  const { name, bio, embeddedWidgetCode, imageURL } = attraction
  const { formatMessage } = intl

  return (
    <div className={style.headlinerCardWrapper}>
      <div>
        <AttractionImage
          src={imageURL}
          name={name}
          additionalClasses={style.headlinerCardImage}
        />
        <div className={style.headlinerDescriptionWrapper}>
          <div className={style.attractionCardTitle}>
            {name}
          </div>
          {
            embeddedWidgetCode ?
              <div className={style.headlinerCardWidget}>
                <AttractionWidget widgetCode={embeddedWidgetCode} />
              </div>
              :
              bio &&
                <div className={style.headlinerCardDescription}>
                  {bio}
                </div>
          }
        </div>
      </div>
      <button className={style.readMoreBtn} onClick={onClick}>
        {formatMessage(locale.readMore)}
      </button>
    </div>
  )
}

export const HeadlinerAttractionCard = injectIntl(HeadlinerAttractionCardComponent)
